import { Component, inject } from '@angular/core';
import { SessionInactivityService } from '@services/DOM/session-inactivity.service';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { NgIconComponent } from "@ng-icons/core";

@Component({
  selector: 'app-inactivity-warning',
  standalone: true,
  templateUrl: './inactivity-warning.component.html',
  imports: [DialogModule, ButtonModule, NgIconComponent],
  styleUrls: ['./inactivity-warning.component.scss']
})
export class InactivityWarningComponent {
  session = inject(SessionInactivityService);
}
